import {DropDownButton} from "@progress/kendo-react-buttons";

export const FormDropdownMultiCheckbox = (fieldProps: any) => {
    const { validationMessage, visited, label, id, valid, ...others } = fieldProps;
    const showValidationMessage = visited && validationMessage;

    return (
        <div>
            <label style={{ fontWeight: 600 }} htmlFor={id} className={'k-label'}>
                {label}
            </label>
            <DropDownButton
                {...others}
                id={id}
            />
            {showValidationMessage && (
                <div className="k-form-error k-text-start">{validationMessage}</div>
            )}
        </div>
    );
};
